import React, { useState } from 'react';
import './Login.css';
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import { auth } from '../firebase';
import { sendPasswordResetEmail } from 'firebase/auth';

const ForgetPassword = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        // Handle login logic here
        sendPasswordResetEmail(auth, email)
            .then(() => {
                alert('Password reset email sent, please check your email inbox, if you dont see it check your spam or junk folder');
            })
            .catch((error) => {
                const errorCode = error.code;
                // const errorMessage = error.message;
                alert('failed in sending password reset email:', errorCode);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <h2>DATY ADMIN</h2>
                    <p>{t('authorized-for-daty-abaya-tz-admin-only')}</p>
                </div>
                <form className="login-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="email">{t('email')}</label>
                        <input
                            type="email"
                            id="email"
                            placeholder={t('enter-your-email')}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    {
                        loading ? (
                            <div className="loader"></div>
                        ) : (
                            <button type="submit" className="login-btn">
                                send email
                            </button>
                        )
                    }
                </form>
                <a href="/login" className="forgot-password" >
                    {t('back-to-login')}
                </a>
                <a href="/" target='_parent' style={{ textDecoration: "none" }}>
                    {t('back-to-main-page')}
                </a><br />
                {/* {
                    i18n.language === "sw" ? (
                        <button style={{ textDecoration: "none",border: "none", backgroundColor:"transparent", color:"black"}} onClick={() => changeLanguage("en")}>
                            english
                        </button>
                    ) : (
                        <button style={{ textDecoration: "none",border: "none", backgroundColor:"transparent", color:"black" }} onClick={() => changeLanguage("sw")}>
                            swahili
                        </button>
                    )
                } */}

            </div>
        </div>
    );
};

export default ForgetPassword;
